import React from 'react';
import { EnrichedTagsLayout, OnTagsEvent, ShowMoreTagsItemProps, Tag, TagItemProps } from '../../../types';

export interface TagsContextProviderProps {
    tags: Tag[];
    tagsLayout: EnrichedTagsLayout;
    numOfLines: number;
    isLoading: boolean;
    shownTags: Tag[];
    showAllTags: () => void;
    hiddenTagsCount: number;
    onShowMoreTags: OnTagsEvent;
    onViewTags?: OnTagsEvent;
    TagItem: React.FC<TagItemProps>;
    ShowMoreTagsItem: React.FC<ShowMoreTagsItemProps>;
}

export const TagsContext = React.createContext<TagsContextProviderProps>({} as TagsContextProviderProps);

export const useTagsContext = () => {
    const context = React.useContext(TagsContext);

    if (context === undefined) {
        throw new Error('useTagsContext must be used within a TagsContextProvider');
    }

    return context;
};
